import { DeletePersons } from 'Apollo/mutations/person/DeletePersons';
import { GetPersonsTotalCount } from 'Apollo/queries/person/GetPersonsTotalCount';
import { useParams } from 'react-router-dom';
import RemoveUsersConfirmation from './RemoveUsersConfirmation';
import useRemoveUsersMutation from './useRemoveUsersMutation';

interface Props {
  selectedUserIds: string[];
  selectAllUserEnabled: boolean;
  selectedUserCount: number;
  userFilter: string | null;
  onCollapse: () => void;
  onReloadUsers: () => void;
}

const RemoveUsers = (props: Props) => {
  const { accountCode } = useParams<IUriParams>();
  const {
    selectedUserIds,
    selectAllUserEnabled,
    selectedUserCount,
    userFilter,
    onCollapse,
    onReloadUsers
  } = props;

  const { loading, onSubmit } = useRemoveUsersMutation<
    RemovePersonData,
    RemovePersonVariables
  >({
    mutation: DeletePersons,
    batchErrorCode: 'E247',
    refetchQueries: [
      {
        query: GetPersonsTotalCount,
        variables: {
          personFilter: {
            accountCode: accountCode === 'all' ? null : accountCode
          }
        }
      }
    ],
    selectedUserCount,
    onCollapse,
    onReloadUsers,
    getVariables: () => ({
      personIds: selectAllUserEnabled ? null : selectedUserIds,
      filter: userFilter
    })
  });

  return (
    <RemoveUsersConfirmation
      selectedUserCount={selectedUserCount}
      loading={loading}
      confirmationMessageId="page.users.action.delete.confirmation"
      onSubmit={onSubmit}
      onCollapse={onCollapse}
    />
  );
};

export default RemoveUsers;
